<template>
  <div class="app-container">
    <div class="filter-container">
      <el-row type="flex" justify="start">
        <el-button
          size="small"
          class="filter-item"
          type="primary"
          icon="el-icon-plus"
          @click="add"
          >新增公告</el-button
        >
      </el-row>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="中文公告概述" width="220">
        <template slot-scope="scope">
          {{ scope.row.lang.title }}
        </template>
      </el-table-column>
      <el-table-column label="发布时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.publish_at }}
        </template>
      </el-table-column>
      <el-table-column label="公告类型" min-width="70" align="center">
        <template slot-scope="scope">
          {{ type(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column label="截止报名时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.end_at ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="发放积分" min-width="70" align="center">
        <template slot-scope="scope">
          {{ scope.row.reward_value ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="发布类型" min-width="70" align="center">
        <template slot-scope="scope">
          {{ publish_type(scope.row.publish_type) }}
        </template>
      </el-table-column>
      <el-table-column label="发布状态" min-width="70" align="center">
        <template slot-scope="scope">
          <!-- {{ publish_status(scope.row.publish_status) }} -->
          <el-tag
            v-if="scope.row.publish_status === 'published'"
            type="success"
          >
            已发布
          </el-tag>
          <el-tag
            v-else-if="scope.row.publish_status === 'unpublished'"
            type="danger"
          >
            未发布
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        min-width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button type="warning" @click="edit(scope.row)" size="mini">
            修改
          </el-button>
          <el-button
            size="mini"
            type="primary"
            v-if="scope.row.publish_status == 'unpublished'"
            @click="publish(scope.row)"
          >
            发布
          </el-button>
          <el-button size="mini" type="primary" @click="del(scope.row)">
            删除
          </el-button>
          <div style="margin-top: 5px">
            <download-excel
              v-if="scope.row.type == 'activity_notice'"
              class="filter-item"
              :fields="json_fields"
              :fetch="registrationLogs"
              type="xls"
              name="数据统计.xls"
              worksheet="数据统计"
            >
              <el-button
                size="mini"
                type="success"
                :loading="scope.row.exportLoading"
                @click="before(scope.row)"
              >
                导出报名名单
              </el-button>
            </download-excel>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="驳回"
      :visible.sync="rejectModalVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            placeholder="驳回理由"
            :rows="4"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject('rejectForm')"
            >确认</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import downloadExcel from 'vue-json-excel'
export default {
  components: { downloadExcel },
  data() {
    return {
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        nickname: '',
        is_forbidden: '',
      },
      exportLoading: false,
      logid: '',
      json_fields: {
        id: {
          field: 'id',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        用户名: {
          field: 'contact',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
      },
    }
  },
  created() {
    this.getList()
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  computed: {
    publish_status() {
      return (val) => {
        switch (val) {
          case 'unpublished':
            return '未发布'
          case 'published':
            return '已发布'
        }
      }
    },
    publish_type() {
      return (val) => {
        switch (val) {
          case 'whitelist':
            return '特定人群'
          case 'all_user':
            return '全部用户'
          case 'all_vip':
            return '全部会员'
        }
      }
    },
    type() {
      return (val) => {
        switch (val) {
          case 'system_message':
            return '系统消息'
          case 'system_notice':
            return '系统公告'
          case 'activity_notice':
            return '活动公告'
        }
      }
    },
  },
  methods: {
    publish(row) {
      this.$confirm('是否确认发布？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/message/publish',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    del(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/message/del',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    before(row) {
      console.log(row)
      row.exportLoading = true
      this.logid = row.id
    },
    registrationLogs() {
      this.exportLoading = true
      return request({
        url: '/api/backend/message/registrationLogs',
        method: 'get',
        params: {
          id: this.logid,
        },
      })
        .then((response) => {
          console.log(response)
          return response.data.data
        })
        .finally(() => {
          this.exportLoading = false
          this.list = this.list.map((item) => {
            return {
              ...item,
              exportLoading: false,
            }
          })
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/message/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data.map((item) => {
          return {
            ...item,
            exportLoading: false,
          }
        })
        console.log(this.list)

        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(val) {
      this.$router.push('/bulletin/edit?id=' + val.id)
    },
    add(val) {
      this.$router.push('/bulletin/edit')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
